module.exports = __webpack_public_path__ + "img/autor.14864888.gif";